import theme from './constants/theme-constants';
export default async function themeLoader(envTheme) {
  try {
    switch (envTheme) {
      case theme.sr:
        await import('./styles/themes/theme.default.scss');
        break;
      case theme.ue:
        await import('./styles/themes/theme.default.scss');
        break;
      case theme.bruno:
        await import('./styles/themes/theme.default.scss');
        break;
      case theme.sample:
        await import('./styles/themes/theme.sample.scss');
        break;
      case theme.softrig:
        await import('./styles/themes/theme.softrig.scss');
        break;
      default:
        await import('./styles/themes/theme.default.scss');
        break;
    }
  } catch (error) {
    console.error('import failed', error);
  }
}
